<app-academies-header></app-academies-header>
<section class="body-section academies-profile-inner">
    <div class="container">
        <main>
            <p-toast key="toastmsg"></p-toast>
            <div class=" col-md-12 bottom-container tablesections">
                <div class="header-container box w-100">
                    <div class="col-md-12 d-flex justify-content-between mb-3 headers-headings">
                        <h3 class="section-header">BRANCHES

                        </h3>

                        <div class="add-edit-btn">
                            <ul>
                                <li>
                                    <button class="add-btn-main" (click)="openmodal()">
                                        <i class='bx bx-plus'></i> Add
                                    </button>
                                </li>
                            </ul>
                        </div>

                    </div>
                    <div class="col-md-12 top-player p-0">
                        <div class="swiper branch-list-div  branch-list-divslider main">
                            <div class="swiper-wrapper">
                                <div class="col-sm-12 branch-list-div heiglght-div p-0">

                                    <div *ngFor="let branch of branchlist" class="swiper-slide">
                                        <div class="blog_card">
                                            <div class="edit-button-show-click">
                                                <button (click)="onClickEdit(branch.id)"><i
                                                        class='bx bx-pencil'></i></button>
                                                <button class="delete-btn" (click)="onClickDelete(branch)"><i
                                                        class='bx bx-trash'></i></button>
                                            </div>
                                            <div class="media">
                                                <div class="media-left">
                                                    <img src="{{branch.image}}" alt="" class="w-100">
                                                </div>
                                                <div class="media-body">
                                                    <div class="Name ">
                                                        <h4>{{branch.name}}</h4>
                                                    </div>
                                                    <div class="contact-us-buttons">
                                                        <ul>
                                                            <li class="ui-list"><a href="#"><i class="bi bi-geo-alt"
                                                                        style="font-size: 20px;color: #686868;"></i></a>{{branch.address}}
                                                            </li>
                                                            <li class="ui-list"><a href="#"><i class="bx bx-phone-call"
                                                                        style="font-size: 20px;color: #686868;"></i></a>{{branch.mobileNumber}}
                                                            </li>
                                                            <li class="ui-list"><a href="#"><i class="bx bx-envelope"
                                                                        style="font-size: 20px;color: #686868;"></i></a>{{branch.email}}
                                                            </li>
                                                            <li class="ui-list"><a href="#"><i class="bx bx-globe"
                                                                        style="font-size: 20px;color: #686868;"></i></a>{{branch.webUrl}}
                                                            </li>
                                                            <!-- <li>
                                                                <a href="#">
                                                                    <button>
                                                                        <div class="location list">
                                                                            <span><i class="bi bi-geo-alt"></i></span>
                                                                            {{branch.address}}
                                                                        </div>
                                                                    </button>
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="tel:1234567890">
                                                                    <button class="Call">
                                                                        <span><i class="bx bx-phone-call"></i></span>
                                                                        {{branch.mobileNumber}}
                                                                    </button>
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="mailto:{{branch.email}}" target="_blank">
                                                                    <button class="email">
                                                                        <span><i class="bx bx-envelope"></i></span>
                                                                        {{branch.email}}
                                                                    </button>
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a style="cursor: default;">
                                                                    <button class="email" style="cursor: default;">
                                                                        <span><i class="bx bx-globe"></i></span>
                                                                        {{branch.webUrl}}
                                                                    </button></a>
                                                            </li> -->
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <!-- <div class="swiper-button-next"></div>
                            <div class="swiper-button-prev"></div>
                            <div class="swiper-pagination"></div> -->
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</section>
<!-- Modal -->
<p-dialog [closable]="true" header="Header" [(visible)]="showingForm" [modal]="true" [style]="{width: '24vw'}"
    [breakpoints]="{'960px': '60vw', '768px': 'calc(100% - 30px)'}" [baseZIndex]="10000"
    (onHide)="onHighlightModalClose()" [draggable]="false" [resizable]="false" class=" add-edit-modal">
    <ng-template pTemplate="header">
        <span class="text-xl font-bold">{{pagetitle}}</span>
    </ng-template>
    <div class="modal-body">
        <form class="form" [formGroup]="branchform" novalidate="" (ngSubmit)="onsubmit()">
            <label for="name_login mb-3">Upload Image</label>
            <div class="col-md-12 upload-image-div p-0">
                <img *ngIf="showUploadedpic" id="blah" src="{{Imagebranch}}" />
                <!-- <img *ngIf="!showUploadedpic" id="blah" src="assets/img/acadmy-details/180.png" alt="your image" /> -->
                <p-fileUpload name="myfile[]" maxFileSize="{{imageSize}}" customUpload="true"
                    (uploadHandler)="picUploader($event)" accept="image/*" auto="auto">
                </p-fileUpload>
            </div>
            <div class="row form-field-section">
                <div class="col">

                    <div class="p-field p-col-12 mb-0 pb-0 pl-0 pr-0">
                        <label for="name">Branch Name <span class="mandatory-fields">*</span></label>
                        <input formControlName="name" type="text" pInputText class="form-control"
                            [ngClass]="{ 'is-invalid': ((submitted && f.name.errors) || (f.name.errors && (f.name.dirty || f.name.touched))) }"
                            placeholder="Enter Branch Name">
                        <div *ngIf="((submitted && f.name.errors) || (f.name.errors && (f.name.dirty || f.name.touched)))"
                            class="invalid-feedback">
                            <div *ngIf="f.name.errors.required">
                                Branch name is required.
                            </div>
                            <div *ngIf="!f.name.errors.required">
                                Please enter valid Branch name.
                            </div>
                        </div>
                    </div>
                    <div class="p-field p-col-12 p-0  pl-0 pr-0">
                        <label for=" mobileNumber" class="p-col-12 pl-0 pr-0 mb-0">Phone Number <span
                                class="mandatory-fields">*</span></label> <p-inputNumber mode="decimal"
                            [useGrouping]="false" formControlName="mobileNumber" class="w-100 p-col-12 mb-0 p-0"
                            [ngClass]=" { 'is-invalid' : ((submitted && f.mobileNumber.errors) || (f.mobileNumber.errors && (f.mobileNumber.dirty || f.mobileNumber.touched)))}"
                            required placeholder="Enter Phone Number">
                        </p-inputNumber>
                        <div *ngIf="((submitted && f.mobileNumber.errors) || (f.mobileNumber.errors && (f.mobileNumber.dirty || f.mobileNumber.touched)))"
                            class="invalid-feedback">
                            <div *ngIf="f.mobileNumber.errors.required">
                                Phone Number is required.</div>
                            <div *ngIf="!f.mobileNumber.errors.required">
                                Please enter valid Phone Number.</div>
                        </div>

                    </div>

                    <div class="p-field p-col-12 pt-0  pl-0 pr-0 mb-0">
                        <label for=" email">Email </label>
                        <input formControlName="email" type="text" pInputText class="form-control"
                            [ngClass]="{ 'is-invalid': ((submitted && f.email.errors) || (f.email.errors && (f.email.dirty || f.email.touched))) }"
                            placeholder="Enter Email ">
                        <div *ngIf="((submitted && f.email.errors) || (f.email.errors && (f.email.dirty || f.email.touched)))"
                            class="invalid-feedback">
                            <div *ngIf="f.email.errors.required">
                                Email is required.</div>
                            <div *ngIf="!f.email.errors.required">
                                Please enter valid Email.</div>
                        </div>
                    </div>
                    <div class="p-field p-col-12 pt-0 pl-0 pr-0  mb-0">
                        <label for="webUrl">Website URL </label>
                        <input formControlName="webUrl" type="text" pInputText class="form-control"
                            [ngClass]="{ 'is-invalid': ((submitted && f.webUrl.errors) || (f.webUrl.errors && (f.webUrl.dirty || f.webUrl.touched))) }"
                            placeholder="Enter Website URL ">
                        <div *ngIf="((submitted && f.webUrl.errors) || (f.webUrl.errors && (f.webUrl.dirty || f.webUrl.touched)))"
                            class="invalid-feedback">
                            <div *ngIf="f.webUrl.errors.required">
                                website url is required.</div>
                            <div *ngIf="!f.webUrl.errors.required">
                                Please enter valid url.</div>
                        </div>
                    </div>
                </div>
                <div class="p-field p-col-12 pt-0  mb-0 pb-0">
                    <label for="address">Street
                        Address </label>
                    <input formControlName="address" type="text" pInputText class="form-control"
                        [ngClass]="{ 'is-invalid': ((submitted && f.address.errors) || (f.address.errors && (f.address.dirty || f.address.touched))) }"
                        placeholder="Enter Street Address">
                    <div *ngIf="((submitted && f.address.errors) || (f.address.errors && (f.address.dirty || f.address.touched)))"
                        class="invalid-feedback">
                        <div
                            *ngIf="((submitted && f.address.errors) || (f.address.errors && (f.address.dirty || f.address.touched)))">
                            Street Address is required.</div>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="p-field p-col-6 mb-0">
                    <label for="countryname" class="p-col-12 p-0">Country </label>
                    <p-dropdown inputId="countryname" [options]="countrylist" formControlName="countryname"
                        appendTo="body" [filter]="true" (onChange)="getStates('true',$event)"
                        placeholder="Select Country" optionLabel="name"
                        [ngClass]="{ 'is-invalid': ((submitted && f.countryname.errors) || (f.countryname.errors && (f.countryname.dirty || f.countryname.touched))) }"></p-dropdown>
                    <div *ngIf="((submitted && f.countryname.errors) || (f.countryname.errors && (f.countryname.dirty || f.countryname.touched)))"
                        class="invalid-feedback">
                        <div *ngIf="f.countryname.errors.required">
                            Please select country.</div>
                    </div>
                </div>
                <div class="p-field p-col-6 mb-0">
                    <label for="statename" class="p-col-12  p-0">State</label>
                    <p-dropdown inputId="statename" [options]="statelist" formControlName="statename" [filter]="true"
                        appendTo="body" (onChange)="getCities('true', $event)" placeholder="Select State"
                        optionLabel="name"
                        [ngClass]="{ 'is-invalid': ((submitted && f.statename.errors) || (f.statename.errors && (f.statename.dirty || f.statename.touched))) }"></p-dropdown>
                    <div *ngIf="((submitted && f.statename.errors) || (f.statename.errors && (f.statename.dirty || f.statename.touched)))"
                        class="invalid-feedback">
                        <div *ngIf="f.statename.errors.required">
                            Please select State.</div>
                    </div>
                </div>
                <div class="p-field p-col-6 mb-0">
                    <label for="cityname" class="p-col-12  p-0">City
                    </label>
                    <p-dropdown inputId="cityname" [options]="citylist" formControlName="cityname" [filter]="true"
                        appendTo="body" placeholder="Select City" optionLabel="name" (onChange)="onCitySelect($event)"
                        [ngClass]="{ 'is-invalid': ((submitted && f.cityname.errors) || (f.cityname.errors && (f.cityname.dirty || f.cityname.touched))) }"></p-dropdown>
                    <div *ngIf="((submitted && f.cityname.errors) || (f.cityname.errors && (f.cityname.dirty || f.cityname.touched)))"
                        class="invalid-feedback">
                        <div *ngIf="f.cityname.errors.required">
                            Please select city.</div>
                    </div>
                </div>
                <div class="p-field p-col-6 mb-0">
                    <label for="zipcode" class="p-col-12  p-0">Zip Code </label>
                    <input formControlName="zipcode" type="text" maxlength="10" placeholder="Enter Zip Code" pInputText
                        class="form-control"
                        [ngClass]="{ 'is-invalid': ((submitted && f.zipcode.errors) || (f.zipcode.errors && (f.zipcode.dirty || f.zipcode.touched))) }">
                    <div *ngIf="((submitted && f.zipcode.errors) || (f.zipcode.errors && (f.zipcode.dirty || f.zipcode.touched)))"
                        class="invalid-feedback">
                        <div *ngIf="f.zipcode.errors.required">
                            Please enter zip code.</div>
                    </div>
                </div>
            </div>
            <div class="modal-footer justify-content-center">
                <button type="submit" class="btn btn-primary p-0">
                    <span *ngIf="isAddMode">Save</span>
                    <span *ngIf="!isAddMode">Update</span>
                </button>
            </div>
        </form>
    </div>
</p-dialog>
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- 
<div class="modal fade" id="edit-modal" tabindex="-1" aria-labelledby="add-modalModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered add-edit-modal modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="add-modalModalLabel">Edit Courts Types</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"> <i
                        class='bx bx-x'></i></button>
            </div>
            <div class="modal-body">
                <form class="form" novalidate="">
                    <label for="name_login mb-3">Upload Image</label>
                    <div class="col-md-12 upload-image-div">
                        <img id="blah" src="assets/img/acadmy-details/stages_adultes_tennis.png" alt="your image" />

                        <input type='file' onchange="readURL(this);" />

                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="row mb-3">
                                <div class="Lastname col-12">
                                    <label for="name_login mb-3">Branches Name</label>
                                    <div class="clear"></div>
                                    <input id="name_login" name="name_login" type="text"
                                        placeholder="Enter Branches Name" required="" class="form-control"
                                        value="Younirise Tennis Academy">
                                </div>

                                <div class="col-12 mt-3">
                                    <div class="form-group">
                                        <label>* Phone Number</label>
                                        <input class="form-control" type="text" placeholder="1234567890"
                                            value="1234567890">
                                    </div>
                                </div>
                                <div class="col-12 mt-3">
                                    <div class="form-group">
                                        <label>* Email</label>
                                        <input class="form-control" type="text" placeholder="user@example.com"
                                            value="test@email.com">
                                    </div>
                                </div>
                                <div class="col-12 mt-3">
                                    <div class="form-group">
                                        <label>* Website Url</label>
                                        <input class="form-control" type="text" placeholder="Website Enter Url "
                                            value="imgacademy.com">
                                    </div>
                                </div>


                            </div>
                            <div class="row mb-0">
                                <div class="Firstname col-12">
                                    <label for="name_login mb-3">Street
                                        Address *</label>
                                    <div class="clear"></div>
                                    <input id="name_login" name="name_login" type="text" placeholder="Enter Street Address
                                       " required="" class="form-control" value="Kokne Chowk Road Pimple Saudagar">
                                </div>

                            </div>
                            <div class="row mb-3">
                                <div class="city col-6 mt-3">
                                    <label for="name_login">*
                                        Country</label>
                                    <div class="clear"></div>
                                    <select class="form-select" aria-label=".form-select-sm example">
                                        <option selected="">India
                                        </option>
                                        <option value="1">One</option>
                                        <option value="2">Two</option>
                                        <option value="3">Three</option>
                                    </select>
                                </div>
                                <div class="Gender  col-6 mt-3">
                                    <label for="name_login">*
                                        State</label>
                                    <div class="clear"></div>
                                    <select class="form-select" aria-label=".form-select-sm example">
                                        <option selected="">Maharashtra
                                        </option>


                                    </select>
                                </div>
                                <div class="city col-6 mt-3">
                                    <label for="name_login">*
                                        City:</label>
                                    <div class="clear"></div>
                                    <select class="form-select" aria-label=".form-select-sm example">
                                        <option selected="">Mumbai
                                        </option>

                                    </select>
                                </div>
                                <div class="city col-6 mt-3">
                                    <label for="name_login mb-3">Zip
                                        Code *</label>
                                    <div class="clear"></div>
                                    <input id="name_login" name="name_login" type="text" placeholder="Enter Zip Code
                                       " required="" class="form-control" value="40000">
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer justify-content-center">

                <button type="button" class="btn btn-primary">Save changes</button>
            </div>
        </div>
    </div>
</div> -->